import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ArrowUpRight, ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { LEGAL_DOCS } from "../../content/legal";

export const Wordmark = ({ className = "" }) => (
  <span
    className={`font-spartan font-bold leading-none tracking-[-0.02em] text-black ${className}`}
  >
    vibealone
  </span>
);

export default function Header() {
  const [comingSoonOpen, setComingSoonOpen] = useState(false);
  const location = useLocation();
  const legalActive = LEGAL_DOCS.some((d) => d.slug === location.pathname);

  return (
    <header
      data-testid="site-header"
      className="mx-auto flex h-[86px] w-full max-w-[1366px] items-center justify-between px-5 md:h-[197px] md:px-[77px]"
    >
      <Link
        to="/"
        data-testid="header-logo-link"
        aria-label="Vibealone home"
        className="rounded-sm focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black"
      >
        <Wordmark className="text-[26px] md:text-[42px]" />
      </Link>

      <nav
        aria-label="Primary"
        className="flex items-center gap-5 md:gap-[80px]"
      >
        <NavLink
          to="/"
          data-testid="nav-home-link"
          className="font-glacial text-[15px] leading-none text-[#7C7C7C] transition-colors hover:text-black md:text-[24px]"
        >
          Home
        </NavLink>

        <DropdownMenu>
          <DropdownMenuTrigger
            data-testid="nav-legal-trigger"
            aria-label="Legal documents menu"
            className={`flex items-center gap-1 font-glacial text-[15px] leading-none transition-colors hover:text-black focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black md:text-[24px] ${
              legalActive ? "text-black" : "text-[#7C7C7C]"
            }`}
          >
            Legal
            <ChevronDown className="h-3.5 w-3.5 md:h-5 md:w-5" aria-hidden="true" />
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            className="min-w-[220px] rounded-xl border-neutral-200 p-2"
            data-testid="nav-legal-menu"
          >
            {LEGAL_DOCS.map((doc) => (
              <DropdownMenuItem key={doc.slug} asChild className="rounded-lg px-3 py-2.5">
                <Link
                  to={doc.slug}
                  data-testid={`nav-legal-${doc.slug.slice(1)}`}
                  className="font-glacial text-[15px] text-neutral-800"
                >
                  {doc.title}
                </Link>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>

        <button
          type="button"
          data-testid="get-app-button"
          onClick={() => setComingSoonOpen(true)}
          className="flex items-center gap-1.5 rounded-full bg-black font-spartan font-bold text-[11px] leading-none text-white transition-opacity hover:opacity-80 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black px-4 py-2.5 md:px-6 md:py-3 md:text-[15px]"
        >
          Get the app
          <ArrowUpRight className="h-3 w-3 md:h-4 md:w-4" strokeWidth={2.75} aria-hidden="true" />
        </button>
      </nav>

      <Dialog open={comingSoonOpen} onOpenChange={setComingSoonOpen}>
        <DialogContent data-testid="get-app-dialog" className="max-w-[420px] rounded-2xl">
          <DialogHeader>
            <DialogTitle className="font-spartan text-[22px] font-bold">
              Coming soon
            </DialogTitle>
            <DialogDescription className="font-glacial text-[16px] leading-relaxed text-neutral-600">
              Vibealone is not yet publicly released on the App Store or Google
              Play. The official store links will appear here as soon as the app
              launches.
            </DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>
    </header>
  );
}
